import { IconCopy } from "@tabler/icons-react";
import { ReactNode } from "react";
import notify from "@common/helpers/NotificationManager";
import { __ } from "@common/helpers/i18n";
import { IconButton } from "./Button";
import { Label } from "./Label";

type CopyValueProps = {
  label?: ReactNode;
  value?: string;
  description?: ReactNode;
};

export function CopyValue({ label, value, description }: CopyValueProps) {
  function copyValue() {
    if (!value) return;

    navigator.clipboard
      .writeText(value)
      .then(() => notify.success(__("Text copied!")))
      .catch(() => {
        const textarea = document.createElement("textarea");
        textarea.value = value;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        textarea.remove();
        notify.success(__("Text copied!"));
      });
  }

  return (
    <div className="grid min-w-0 gap-2">
      {label && <Label label={label} />}
      <div className="grid min-h-11 min-w-0 grid-cols-[minmax(0,1fr)_auto] items-center gap-2 overflow-hidden rounded-md border border-input bg-card px-2 py-1.5">
        <div
          dir="ltr"
          className="min-w-0 overflow-hidden truncate px-2 text-left text-sm font-semibold leading-6 text-foreground"
          title={value}
        >
          {value || "-"}
        </div>
        <IconButton
          type="button"
          aria-label={__("Copy")}
          tooltip={__("Copy")}
          icon={<IconCopy size={16} stroke={2} />}
          variant="outline-light"
          padding="none"
          className="h-10 w-10 shrink-0 rounded-md md:h-8 md:w-8"
          disabled={!value}
          onClick={copyValue}
        />
      </div>
      {description && (
        <p className="text-sm leading-5 text-muted-foreground">{description}</p>
      )}
    </div>
  );
}
